import React from 'react';
import "./dataIntegrity.scss";

//Imagens:
import ImgDataIntegrity from "../../../../assets/dataManagement/dataIntegrity.png";
import { useTranslation } from 'react-i18next';

function DataIntegrity() {
    const { t } = useTranslation()
    return (
        <div className='container-data-integrity'>
            <div className='img-data-integrity'>
                <img src={ImgDataIntegrity} alt="" />
            </div>
            <div className='text-data-integrity'>
                <h1>{t("datasources.data_integrity.title")}</h1>
                <p>{t("datasources.data_integrity.section_text")} </p>
            </div>
        </div>
    )
}

export default DataIntegrity